module.exports = {
    content: ['./public/**/*.html', './src/**/*.{vue,js,ts,jsx,tsx}'],
    theme: {
        extend: {
            height: {
                '28rem': '28rem',
                '32rem': '32rem',
                '29rem': '29rem',
                '26.25rem': '26.25rem',
            },
            width:{
                '700px': '700px'
            }
        },
    },
    safelist: [
        {
            pattern: /bg-/
        },
        {
            pattern: /text-/
        },
    ],
    variants: {},
    plugins: [],
    modules: {},
}
